import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" action: the intent the UI dispatches for the saga to act on. Kept
 * out of the slice's reducers: it triggers a side effect (the POST), not a state
 * transition (the saga owns the resulting `submit*` transitions).
 *
 * No payload: the draft is already in the store, and the write targets the self
 * endpoint `POST /account/password`, where the backend derives the user from the
 * session; so neither the id nor the secrets travel through the action.
 */
export const submitRequested = createAction('passwordChange/submitRequested');
